<template>
  <div class="index">
    <div class="index-header">
      <el-form :model="form" ref="form" :inline="true" label-width="110px">
        <div class="input-box" style="margin-bottom:18px;">
          <div>
            <el-form-item label="企业名称：" prop="name">
              <el-input v-model="form.name" placeholder="请输入姓名"></el-input>
            </el-form-item>
            <el-form-item label="联系电话：" prop="phone">
              <el-input v-model="form.phone" placeholder="请输入电话"></el-input>
            </el-form-item>
          </div>
          <div>
            <label style="margin:5px 10px 0 50px;">地区：</label>
          </div>
          <div style="margin-right:10px">
            <Area :value="area_data" :diss="dis" :arr="arrPlace1" @getPlace="getPlace1"/>
          </div>
          <div style="margin-right:10px">
            <el-form-item label="开始时间：" prop="startCreateTime">
              <el-date-picker type="date" v-model="form.startCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
            <el-form-item label="结束时间：" prop="endCreateTime">
              <el-date-picker type="date" v-model="form.endCreateTime" value-format="timestamp" placeholder="选择日期" />
            </el-form-item>
          </div>
          <div>
            <el-form-item>
              <el-button
                type="primary" icon="el-icon-search"
                @click=" $data.paging_data.pageSize = $data.paging_data.total = 1 ,
                Filter_file({api:api,data:form,callback:_d => tableData = _d })">查询</el-button>
            </el-form-item>
          </div>
        </div>
      </el-form>
    </div>
    <div class="edit">
      <el-button :disabled="selectRow.length==1?false:true" v-if="showBtn[1].isShow" icon="el-icon-edit" @click="openBox('edit')">编辑</el-button>
      <el-button icon="el-icon-edit" v-if="showBtn[3].isShow" @click="openBox('create')">创建</el-button>
      <el-button icon="el-icon-delete" v-if="showBtn[2].isShow" type="danger" @click="deleteDate('cj_jyfpcjdtgltz')">删除</el-button>
      <el-button style="padding: 0" v-if="showBtn[4].isShow"><file_Upload :_url="$public.upload_url._ee"></file_Upload></el-button>
      <el-button type="primary" 
            v-if="showBtn[5].isShow"
            v-loading.fullscreen.lock="lodaingTime" @click="Filter_export(`${api}/export`,form)" icon="el-icon-document-remove">导出数据</el-button>
      <el-button type="primary" @click="downShow = true" icon="el-icon-document-remove">
        <!-- <a style="color:#fff" href="../model/就业扶贫车间动态管理台账模板.xlsx" download="就业扶贫车间动态管理台账模板.xlsx">下载模板</a> -->
        下载模板
      </el-button>
    </div> 
    <div class="table">
      <el-table
        :data="tableData"
        max-height="550"
        border
        @selection-change="handleSelectionChange"
        style="width: 99.9%">
        <el-table-column
          type="selection"
          width="40">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo"
          :key="index+100"
          :prop="item.key"
          :fixed="index>7?false:true"
          :label="item.value"
          align="center">
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="运营情况"
          align="center">
          <el-table-column
            show-overflow-tooltip
            v-for="(item,index) in baseInfo1"
            :key="index+300"
            :prop="item.key"
            :label="item.value"
            align="center">
          </el-table-column>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          label="补贴政策落实情况（万元）"
          align="center">
          <el-table-column
            show-overflow-tooltip
            v-for="(item,index) in baseInfo2"
            :key="index"
            :prop="item.key"
            :label="item.value"
            align="center">
          </el-table-column>
        </el-table-column>
        <el-table-column
          show-overflow-tooltip
          v-for="(item,index) in baseInfo3"
          :key="index+600"
          :prop="item.key"
          :label="item.value"
          align="center">
        </el-table-column>
      </el-table>
      <paging
          :pagesData="$data.paging_data"
          @set_page_number = 'get_page_number'
      ></paging>
    </div>
    <!-- 模态框 -->
    <el-dialog
      title="就业扶贫车间动态管理台账"
      :visible.sync="centerDialogVisible"
      @close="close"
      width="1400px"
      :modal="false"
      :close-on-click-modal="false"
      center>
      <div>
        <div class="edit-box">
          <div class="edit-item">
            <div class="edit-left">基本信息</div>
            <div class="edit-right">
              <div class="info-box">
                <div class="info-input">
                  <el-form label-width="210px" size="mini" :rules="rules" ref="editForm" :model="editForm">
                    <el-row>
                      <el-col :span="12">
                        <el-form-item label="地区：">
                          <Area   :value="area_data"
                              :diss="dis"
                              :name="arrPlace"
                              @getPlace="getPlace"/>
                        </el-form-item>
                        <el-form-item prop="name" label="企业名称：">
                          <el-input style="width:193px;" v-model="editForm.name"></el-input>
                        </el-form-item>
                        <el-form-item label="企业地址：">
                          <el-input style="width:193px;" v-model="editForm.address"></el-input>
                        </el-form-item>
                        <el-form-item label="企业经营范围：">
                          <el-input style="width:193px;" v-model="editForm.businessScope"></el-input>
                        </el-form-item>
                        <el-form-item prop="ownerName" label="企业负责人：">
                          <el-input style="width:193px;" v-model="editForm.ownerName"></el-input>
                        </el-form-item>
                        <el-form-item prop="phone" label="联系电话：">
                          <el-input style="width:193px;" v-model="editForm.phone"></el-input>
                        </el-form-item>
                        <el-form-item label="投资金额(万元)：">
                          <el-input style="width:193px;" v-model="editForm.investment"></el-input>
                        </el-form-item>
                        <el-form-item label="资金来源：">
                          <el-input style="width:193px;" v-model="editForm.cashSrc"></el-input>
                        </el-form-item>
                        <el-form-item label="建筑面积：">
                          <el-input style="width:193px;" v-model="editForm.buildArea"></el-input>
                        </el-form-item>
                        <el-form-item label="认定时间：">
                          <el-date-picker
                            style="width:193px;"
                            v-model="editForm.buildTime"
                            value-format="yyyy-MM-dd"
                            format="yyyy-MM-dd"
                            type="date"
                            placeholder="选择日期">
                          </el-date-picker>
                        </el-form-item>
                        <el-form-item label="车间类型：">
                          <el-input style="width:193px;" v-model="editForm.shopType"></el-input>
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="员工人数：">
                          <el-input style="width:193px;" v-model="editForm.persons"></el-input>
                        </el-form-item>
                        <el-form-item label="贫困劳动者人数：">
                          <el-input style="width:193px;" v-model="editForm.poorPersons"></el-input>
                        </el-form-item>
                        <el-form-item label="签订劳动合同或劳务协议贫困劳动者人数：">
                          <el-input style="width:193px;" v-model="editForm.hasContractPersons"></el-input>
                        </el-form-item>
                        <el-form-item label="按规定购买意外伤害保险贫困劳动者人数：">
                          <el-input style="width:193px;" v-model="editForm.insurePersons"></el-input>
                        </el-form-item>
                        <el-form-item label="运营情况（正常）：">
                          <el-input style="width:193px;" v-model="editForm.statusNormal"></el-input>
                        </el-form-item>
                        <el-form-item label="运营情况（停产）：">
                          <el-input style="width:193px;" v-model="editForm.statusStop"></el-input>
                        </el-form-item>
                        <el-form-item label="运营情况（其它）：">
                          <el-input style="width:193px;" v-model="editForm.statusOthers"></el-input>
                        </el-form-item>
                        <el-form-item label="补贴政策落实情况（万元）：">
                        </el-form-item>
                        <el-form-item label="带动就业补贴发放数：">
                          <el-input style="width:193px;" v-model="editForm.jobAllowance"></el-input>
                        </el-form-item>
                        <el-form-item label="其它就业扶贫车间补贴发放数：">
                          <el-input style="width:193px;" v-model="editForm.otherAllowance"></el-input>
                        </el-form-item>
                        <el-form-item label="星级评定：">
                          <el-input style="width:193px;" v-model="editForm.star"></el-input>
                        </el-form-item>
                        <el-form-item label="备注：">
                          <el-input type="textarea" style="width:193px;" v-model="editForm.marks"></el-input>
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="centerDialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="submit()">确 定</el-button>
      </span>
    </el-dialog>
    <dowmloadplace :value="type" :downShow="downShow" @cutOff="cutOff"/>
  </div>
</template>
<script>
import mixins from '@/Mixins'
export default {
  mixins:[mixins],
  data() {
    return{
      api:'/user/bobaiHelpPoorManage',
      form:{socialCode:''},
      type:'18',
      isCreate:false,
      centerDialogVisible:false,
      tableData:[],
      selectRow:[],
      rules:{
        name: [
          { required: true, message: '请输入企业名', trigger: 'blur' }
        ],
        ownerName: [
          { required: true, message: '请输入负责人s', trigger: 'blur' }
        ],
        idCard: [
          { required: true, message: '请输入身份证号', trigger: 'blur' },
          { min: 18, max: 18, message: '长度为18个字符', trigger: 'blur' }
        ],
        phone: [
          { required: true, message: '请输入电话', trigger: 'blur' }
        ],
      },
      baseInfo:[
        {key: 'province', value: '省'},
        {key: 'city', value: '市'},
        {key: 'county', value: '县'},
        {key: 'town', value: '镇'},
        {key: 'village', value: '村'},
        {key:'name',value:'企业名称'},
        {key:'address',value:'企业地址'},
        {key:'businessScope',value:'企业经营范围'},
        {key:'ownerName',value:'企业负责人'},
        {key:'phone',value:'联系电话'},
        {key:'investment',value:'投资金额(万元)'},
        {key:'cashSrc',value:'资金来源'},
        {key:'buildArea',value:'建筑面积'},
        {key:'buildTime',value:'认定时间'},
        {key:'shopType',value:'车间类型'},
        {key:'persons',value:'员工人数'},
        {key:'poorPersons',value:'含贫困劳动者人数'},
        // {key:'hasContractPersons',value:'签订劳动合同或劳务协议人数'},
        // {key:'hasInsurancePerson',value:'按规定购买意外伤害保险人数'},
        {key:'hasContractPersons',value:'签订劳动合同或劳务协议贫困劳动者人数'},
        {key:'insurePersons',value:'按规定购买意外伤害保险贫困劳动者人数'},
      ],
      baseInfo1:[
        {key:'statusNormal',value:'正常'},
        {key:'statusStop',value:'停产'},
        {key:'statusOthers',value:'其它'},
      ],
      baseInfo2:[
        {key:'jobAllowance',value:'带动就业补贴发放数'},
        {key:'otherAllowance',value:'其它就业扶贫车间补贴发放数'},
      ],
      baseInfo3:[
        {key:'star',value:'星级评定'},
        {key:'marks',value:'备注'},
      ],
    }
  },
  created() {
    this.isShowBtn("BobaiHelpPoorManage")//控制操作按钮的显示与隐藏
    this.getArea({value:{areaId:0},key:0})
  },
  methods:{
    handleSelectionChange(val) {
      this.selectRow = val
    },
    //分页
    get_page_number(pageNumer) {
      let [vm] = [this]
      vm.form.pageNumber = pageNumer;
      vm.Filter_file({api:vm.api,data:vm.form,callback:_d => vm.tableData = _d})
    },
    //提交请求
    submit() {
      let newForm = {}
      newForm = JSON.parse(JSON.stringify(this.editForm))
      delete newForm.areaId
      
      newForm.buildTime = new Date(newForm.buildTime).getTime()
      newForm.province = this.province
      newForm.city = this.city
      newForm.county = this.county
      newForm.town = this.town
      newForm.village = this.village
      this.$refs['editForm'].validate((valid)=>{
        if (valid && this.isCreate === true) {
          this.$api.create('/user/bobaiHelpPoorManage',newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('创建成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else if (valid && this.isCreate === false) {
          delete newForm.createTime
          this.$api.change('/user/bobaiHelpPoorManage/modify',newForm)
          .then(res =>{
            if (res.data.status === 0) {
              this.$message.success('修改成功!')
              this.Filter_file({ api: this.api, data: this.form, callback: _d => this.tableData = _d })
            } else {
							this._status(res.data)
						}
          })
        } else {
          return false
        }
      })
    },
  }
}
</script>
<style>
/* .index .index-header .el-form-item__content{width: 200px;} */
.el-textarea .el-textarea__inner{resize: none;}
.input-box>div{display: flex;flex-direction: column;flex-shrink: 0;}
.info-title{
  text-align:center;
  margin:48px 0;
  color:rgb(153,153,153);
}
.text .el-form-item__label{
  text-align:justify;
  text-align-last:justify;
}
</style>